import { render, staticRenderFns } from "./frise-parcours.vue?vue&type=template&id=33cab006&scoped=true"
import script from "./frise-parcours.vue?vue&type=script&lang=js"
export * from "./frise-parcours.vue?vue&type=script&lang=js"
import style0 from "./frise-parcours.vue?vue&type=style&index=0&id=33cab006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cab006",
  null
  
)

export default component.exports